import React, { useState, useEffect, useRef } from 'react';
import logo from '../assets/quantena-logo.png';
import '../styles/header.css';

function Header({ onContactClick }) {
  const [scrolled, setScrolled] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [progress, setProgress] = useState(0);
  const lastScrollY = useRef(0);

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const currentY = window.scrollY;
          const docHeight = document.documentElement.scrollHeight - window.innerHeight;

          setScrolled(currentY > 80);
          setHidden(currentY > 400 && currentY > lastScrollY.current);
          setProgress(docHeight > 0 ? (currentY / docHeight) * 100 : 0);

          lastScrollY.current = currentY;
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <div className="scroll-progress" style={{ width: `${progress}%` }} />
      <header className={`header ${scrolled ? 'scrolled' : ''} ${hidden ? 'hidden' : ''}`}>
        <div className="header-logo">
          <img src={logo} alt="Quantena" className="header-logo-image" />
          <span className="header-logo-text">Quantena</span>
        </div>
        <nav aria-label="Primary">
          <button className="header-contact" onClick={onContactClick}>
            <span className="header-status-dot" aria-hidden="true" />
            Contact
          </button>
        </nav>
      </header>
    </>
  );
}

export default Header;
